import { observer } from "mobx-react-lite"

interface IScrollListProps<T> {
	horizontal?: boolean
	gap?: string
	items: T[]
	listEmptyComponent?: React.ReactNode
	renderItem: (item: T, index: number) => JSX.Element
}

export const ScrollList = observer(<T,>({ horizontal, items, gap = "12px", listEmptyComponent, renderItem }: IScrollListProps<T>) => {
	return (
		<div
			className={`
				align-start
				flex
				min-w-full
				flex-nowrap
				justify-start
				${horizontal ? "flex-row overflow-x-auto" : "flex-col overflow-y-auto"}
			`}
		>
			{items.map((item, index) => (
				<div key={index} className={`${index + 1 !== items.length ? `m${horizontal ? "r" : "b"}-[${gap}]` : ""} shrink-0`}>
					{renderItem(item, index)}
				</div>
			))}
			{items.length === 0 && listEmptyComponent}
		</div>
	)
})
